<script>
  import { page } from "$app/stores";
</script>

<div class="max-w-content mx-auto px-8 py-32 my-8">
  <h1 class="text-5xl">{$page.status}: {$page.error.message}</h1>
</div>
